import {
    MIN_THUMBNAIL_HEIGHT,
    MIN_THUMBNAIL_WIDTH,
} from 'modules/campaigns/modules/creative-creator/config/thumbnailValidationConsts';
import { isFileTypeImage } from 'modules/campaigns/modules/creative-creator/services/utils';

const loadImage = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = e => {
            const image = new Image();
            image.onload = () => resolve({ width: image.width, height: image.height });
            image.onerror = () => reject();
            image.src = e.target.result;
        };

        reader.onerror = () => reject();

        reader.readAsDataURL(file);
    });

export const thumbnailValidations = [
    {
        validationFn: async value => {
            const file = value?.file;
            if (!file || !isFileTypeImage(file.type)) return true;
            const { width, height } = await loadImage(file);
            return width >= height;
        },
        messageId: 'creative.editor.tab.aiGenerated.imageToMotion.thumbnail.upload.ratio.error',
        defaultMessage: 'Image ratio validation failed',
    },
    {
        validationFn: async value => {
            const file = value?.file;
            if (!file || !isFileTypeImage(file.type)) return true;
            const { width, height } = await loadImage(file);
            return width >= MIN_THUMBNAIL_WIDTH && height >= MIN_THUMBNAIL_HEIGHT;
        },
        messageId: 'creative.editor.tab.aiGenerated.imageToMotion.thumbnail.upload.size.error',
        defaultMessage: 'Minimum image size validation failed',
    },
];
